<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    dataTask: Object,
    listDate: Array,
    listDesigner: Array,
  },
  data: () => ({
    dataSetDesigner: [],
  }),
  methods: {
    //Designer
    loadDataSetDesigner() {
      var dataTemp = {
        label: "",
        //backgroundColor: "",
        data: [],
      };
      for (const i of this.listDesigner) {
        dataTemp.label = i;
        for (const j in this.dataTask) {
          //console.log("j: ",j)
          for (const k in this.dataTask[j]) {
            //console.log("k: ",k)
            //console.log(this.dataChart[j][k])
            if (i == k) {
              dataTemp.data.push(this.dataTask[j][k]);
            }
          }
        }

        if (dataTemp.label == "daihq92") {
          dataTemp.backgroundColor = "#ef5350";
        } else if (dataTemp.label == "external_designer_01") {
          dataTemp.backgroundColor = "#FFEB3B";
        } else if (dataTemp.label == "external_designer_02") {
          dataTemp.backgroundColor = "#42A5F5";
        } else if (dataTemp.label == "hoanghc") {
          dataTemp.backgroundColor = "#AB47BC";
        } else if (dataTemp.label == "huongnvt") {
          dataTemp.backgroundColor = "#FFA726";
        } else if (dataTemp.label == "kenko") {
          dataTemp.backgroundColor = "#C2185B";
        } else if (dataTemp.label == "lamnht") {
          dataTemp.backgroundColor = "#009688";
        } else if (dataTemp.label == "linhpm") {
          dataTemp.backgroundColor = "#E64A19";
        } else if (dataTemp.label == "ngocntb") {
          dataTemp.backgroundColor = "#00E5FF";
        } else if (dataTemp.label == "nguyenlh") {
          dataTemp.backgroundColor = "#4CAF50";
        } else if (dataTemp.label == "phuonglm") {
          dataTemp.backgroundColor = "#FFD600";
        } else if (dataTemp.label == "quanpm") {
          dataTemp.backgroundColor = "#D500F9";
        } else if (dataTemp.label == "sonpt") {
          dataTemp.backgroundColor = "#4FC3F7";
        } else if (dataTemp.label == "test_designer") {
          dataTemp.backgroundColor = "#607D8B";
        } else if (dataTemp.label == "thangtr") {
          dataTemp.backgroundColor = "#F8BBD0";
        } else if (dataTemp.label == "toanvtd") {
          dataTemp.backgroundColor = "#EA80FC";
        } else if (dataTemp.label == "vylt") {
          dataTemp.backgroundColor = "#B9F6CA";
        }

        this.dataSetDesigner.push(dataTemp);
        dataTemp = {
          label: "",
          //backgroundColor: "",
          data: [],
        };
      }
      console.log(this.dataSetDesigner);
      this.loadChartTask();
    },

    loadChartTask() {
      console.log("loadChartTask");
      this.renderChart(
        {
          labels: this.listDate,
          datasets: this.dataSetDesigner,
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: "bottom" },
          title: {
            display: true,
            text: "Task Completed In Last 30 Days",
          },
          tooltips: {
            mode: "index",
            intersect: false,
            position: "nearest",
          },
          scales: {
            xAxes: [
              {
                stacked: true,
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },
        }
      );
    },
  },
  async mounted() {
    await this.loadDataSetDesigner();
  },
};
</script>